import { Component, OnChanges, OnInit } from '@angular/core';
import {
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { CalendarModule } from 'primeng/calendar';
import { CardModule } from 'primeng/card';
import { DropdownModule } from 'primeng/dropdown';

@Component({
  selector: 'app-turns-statistics',
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    CardModule,
    CalendarModule,
    ButtonModule,
    DropdownModule,
  ],
  templateUrl: './turns-statistics.component.html',
  styleUrl: './turns-statistics.component.css',
})
export class TurnsStatisticsComponent implements OnChanges, OnInit {
  formGroup!: FormGroup;
  cities: { name: string, code: string }[] | undefined;

  constructor() {}

  ngOnInit(): void {
    this.cities = [
            { name: 'New York', code: 'NY' },
            { name: 'Rome', code: 'RM' },
            { name: 'London', code: 'LDN' },
            { name: 'Istanbul', code: 'IST' },
            { name: 'Paris', code: 'PRS' }
        ];
    this.formGroup = new FormGroup({
      date: new FormControl<Date[] | null>(null),
      selectedCity: new FormControl<{ name: string, code: string } | null>(null)
    });
  }

  ngOnChanges(): void {
    // console.log('rango de fechas: ', this.rangeDates);
  }

  onSelectDate(event: any): void {
    console.log('rango de fechas: ', event);
    console.log('formGroup: ', this.formGroup?.value);
  }
}
